<twc-checkbox class="twc-ml-3 twc-mt-3 twc-mb-2">
    <input twcCheckboxInput #inputCheck [attr.checked]="value ? true: null" [disabled]="!property.editable()"
        (change)="onChange(inputCheck.checked)">
    <label twcCheckboxLabel>{{label | translate}}</label>
</twc-checkbox>